// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3RW3q","itemTitle":"ClientEmergencyInfo_itemTitle__1MOlU","itemText":"ClientEmergencyInfo_itemText__33K-B"};